export enum Gravame {
  IPOTECHE_VOLONTARIE = 'IPOTECHE VOLONTARIE',
  SERVITU = "SERVITU'",
  ALTRO = 'ALTRO',
  IPOTECHE_PIGNORAMENTI = 'IPOTECHE LEGALI E PIGNORAMENTI',
  NESSUNO = 'NESSUNO',
}
